import type { VoidComponent } from "solid-js";
import { createMemo } from "solid-js";
import ContentSwitcher from "../../../components/contentSwitcher/ContentSwitcher";
import { useTranslation } from "../../../state/i18n";
import type { SideNavContentSlotProps } from "../sideNav/SideNavContent";
import EditorMenuFields from "./EditorMenuFields";
import EditorMenuFavourites from "./EditorMenuFavourites";
import { useSearchParams } from "@solidjs/router";

export type EditorSearchParams = {
  tab: "fields" | "favourites";
};

const EditorMenu: VoidComponent<SideNavContentSlotProps> = () => {
  const { t } = useTranslation();
  const [query, setQuery] = useSearchParams<EditorSearchParams>();
  const tabKey = createMemo(() => (query.tab === "favourites" ? "favourites" : "fields"));

  return (
    <div class="h-full" data-tour-highlight-id="editor-menu">
      <ContentSwitcher
        tabKey={tabKey()}
        onTabChange={(value) => {
          setQuery({ tab: value });
        }}
        items={[
          {
            key: "fields",
            label: t(($) => $.FIELD_SWITCHER_BUTTON),
            Slot: () => (
              <div class="flex h-full flex-1 shrink-0 flex-col">
                <EditorMenuFields />
              </div>
            ),
          },
          {
            key: "favourites",
            label: t(($) => $.FAVOURITE_SWITCHER_BUTTON),
            Slot: () => (
              <div class="flex h-full flex-1 shrink-0 flex-col">
                <EditorMenuFavourites />
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default EditorMenu;
